function countDecimal(value) {
  if (Math.floor(value) === value) {
    return 0
  }

  return value?.toString().split(".")[1].length || 0;
}

export default function truncateNumber(value, decimal = 2) {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }

  return countDecimal(value) > 1 ? parseFloat(value?.toFixed(decimal)) : value;
}
